import collectionsTab from './collectionsTab';
import newCollectionTab from './newCollectionTab';
import collectionTab from './collectionTab';
import collectionHistoryTab from './collectionHistoryTab';

export default [
  collectionHistoryTab,
  collectionsTab,
  collectionTab,
  newCollectionTab,
];
